import React from 'react';

const WidgetSettingsContext = React.createContext({});

export default WidgetSettingsContext;
